import { createFileRoute } from "@tanstack/react-router";

import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { ClientsMarquee } from "../components/shared/ClientsMarquee";
import { Faq } from "../components/shared/Faq";
import { LeadForm } from "../components/shared/LeadForm";
import { Reviews } from "../components/shared/Reviews";
import { Stats } from "../components/shared/Stats";
import { ExpertHero } from "../components/expert/ExpertHero";
import { ExpertAdvantages } from "../components/expert/ExpertAdvantages";
import { ExpertNiches } from "../components/expert/ExpertNiches";
import { ExpertPricing } from "../components/expert/ExpertPricing";
import { ExpertProcess } from "../components/expert/ExpertProcess";
import { buildMeta, serviceJsonLd, SITE_URL } from "../lib/site";

const title = "Маркетинг для медицинских центров и клиник — hay.agency";
const description =
  "Отраслевая экспертиза: продвижение медицинских центров, клиник и диагностики — стратегия, SEO, контекст, геосервисы и репутация без нарушений рекламных требований.";

const faqItems = [
  {
    q: "Когда будут видны первые результаты?",
    a: "Первоначальные результаты появляются обычно через 2-4 месяца, а стабильный рост можно ожидать в течение 7-12 месяцев.",
  },
  {
    q: "Как вы оцениваете эффективность продвижения?",
    a: "Мы постоянно отслеживаем ключевые показатели и корректируем стратегию для обеспечения роста и максимальной эффективности.",
  },
  {
    q: "Сколько стоит продвижение?",
    a: "Каждый проект уникален. Мы предоставляем подробную смету, согласованную с вами заранее, чтобы вы могли уверенно планировать расходы.",
  },
];

export const Route = createFileRoute("/expert")({
  head: () => ({
    ...buildMeta({ title, description, path: "/expert", image: `${SITE_URL}/og/services/expert.webp`, imageWidth: 1200, imageHeight: 630, imageAlt: "Маркетинг для медицинских центров — HAY.agency", locale: "ru_RU" }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          serviceJsonLd({
            name: "Маркетинг для медицинских центров",
            description,
            path: "/expert",
          }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqItems.map((item) => ({
            "@type": "Question",
            name: item.q,
            acceptedAnswer: { "@type": "Answer", text: item.a },
          })),
        }),
      },
    ],
  }),
  component: Page,
});


function Page() {
  return (
    <ServicePageLayout breadcrumb="Отраслевая экспертиза">
      <ExpertHero />
      <ExpertAdvantages />
      <ClientsMarquee bare />
      <ExpertNiches />
      <ExpertPricing />
      <LeadForm
        id="expert-offer"
        title="Узнайте стоимость продвижения вашего бизнеса"
        lead="Мы свяжемся с вами в течение двух часов, чтобы задать вопросы и обсудить задачу"
        submitLabel="Отправить"
      />
      <ExpertProcess />
      <Reviews />
      <Stats />
      <Faq
        compact
        title="Частые вопросы о продвижении медицинских центров"
        lead="Сроки, оценка эффективности и стоимость продвижения — коротко."
        items={faqItems}
      />
      <LeadForm
        id="expert-cta"
        title="Готовы увеличить количество пациентов?"
        lead="Мы свяжемся с вами в течение двух часов, чтобы задать вопросы и обсудить задачу"
        submitLabel="Получить прототип"
        withSelect
        selectOptions={["Лендинг", "Многостраничный сайт", "Интернет-магазин", "Другая задача"]}
      />
    </ServicePageLayout>
  );
}
